
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as account0Pjo0ewza1Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45accountmm0xW4NHu1Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordZTZSKFIROdMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homedTd6Og5JwIMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/home.vue?macro=true";
import { default as indexSFCAxhbpPTMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/index.vue?macro=true";
import { default as loginkAjXSsFXuIMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/login.vue?macro=true";
import { default as notificationswzrDZ0chDoMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordXHvJfqaOaZMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filtersGhtvjCifFYMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groups3FVkKEq9X1Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93dGrW8ZGHhvMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexQt6CCejuBkMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_93FN5qQcsVABMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clients2EnEI5zM65Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheets1XCOZNogCMMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as indexLY3OyVrA1VMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as new6NaQCSDAkUMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as exportGNvRZVqWZDMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexaKizCC2oyEMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newS3ppmlFyw9Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93J9LPCDTB5OMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as importezTIBUvxdNMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as index6ZaxeD26ECMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createIdk5O5whaWMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_93c7Sz4wQM7MMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_93Keabz10RSRMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexgnW6v9QLEBMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventories9YLcRBKcuEMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventorywqY03yrmhYMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexNS5j58mF34Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activityLchXDYekm0Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndownwKJ19FcJL4Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as indexMAXSkxDdpoMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reportingGUV2YTyzpDMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_93yqCnJ6wcqgMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as index82VomabFv9Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointments9h57flRtWjMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as indexUlpUrSFtb7Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_932sz0wYFtFnMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignment7Ehml8fJC7Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardQZJxVNoKAtMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as index5PPyUkWsO0Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_93cD2O0mYk2EMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorskHE5NPjy9OMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indexMcQ4YuHh3WMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmap8H85dr3M0ZMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexpva8X6Uai8Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasksx7PUQvQhz2Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rolloutjOTZrlMUuJMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointmentRmNMuOgqlPMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as brandingPqQdrwBdilMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createPl1BZjzSaUMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_93WQD3SMDpVqMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as indexXIzTby9JYwMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklistslToGPac1V8Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45links8eDvsPANx7Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsJF3ODglJV0Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as indexqmR5S3KdLHMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrations9NwsQ7TXugMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rolloutsAjZGuOVolmMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptionBznJHshNfSMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as userspPpAFLdWjlMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as createBD804nQBtoMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_93PrhUgHZQOhMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as indexbwk8393i7vMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflowsiPPj7f4Fr6Meta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settings6R8Y5CLfiVMeta } from "/codebuild/output/src1852554866/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: account0Pjo0ewza1Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45accountmm0xW4NHu1Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordZTZSKFIROdMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homedTd6Og5JwIMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexSFCAxhbpPTMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginkAjXSsFXuIMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationswzrDZ0chDoMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordXHvJfqaOaZMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventorywqY03yrmhYMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filtersGhtvjCifFYMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groups3FVkKEq9X1Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clients2EnEI5zM65Meta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93dGrW8ZGHhvMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexQt6CCejuBkMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_93FN5qQcsVABMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheets1XCOZNogCMMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: exportGNvRZVqWZDMeta?.name,
    path: "export",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: indexLY3OyVrA1VMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: new6NaQCSDAkUMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: importezTIBUvxdNMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexaKizCC2oyEMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newS3ppmlFyw9Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93J9LPCDTB5OMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: index6ZaxeD26ECMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventories9YLcRBKcuEMeta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createIdk5O5whaWMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_93c7Sz4wQM7MMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_93Keabz10RSRMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexgnW6v9QLEBMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexNS5j58mF34Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reportingGUV2YTyzpDMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activityLchXDYekm0Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndownwKJ19FcJL4Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: indexMAXSkxDdpoMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rolloutjOTZrlMUuJMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointments9h57flRtWjMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_93yqCnJ6wcqgMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: index82VomabFv9Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignment7Ehml8fJC7Meta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: indexUlpUrSFtb7Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_932sz0wYFtFnMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardQZJxVNoKAtMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorskHE5NPjy9OMeta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: index5PPyUkWsO0Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_93cD2O0mYk2EMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indexMcQ4YuHh3WMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmap8H85dr3M0ZMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasksx7PUQvQhz2Meta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexpva8X6Uai8Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointmentRmNMuOgqlPMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settings6R8Y5CLfiVMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: brandingPqQdrwBdilMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklistslToGPac1V8Meta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createPl1BZjzSaUMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_93WQD3SMDpVqMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: indexXIzTby9JYwMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45links8eDvsPANx7Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsJF3ODglJV0Meta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: indexqmR5S3KdLHMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrations9NwsQ7TXugMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rolloutsAjZGuOVolmMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptionBznJHshNfSMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: userspPpAFLdWjlMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflowsiPPj7f4Fr6Meta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: createBD804nQBtoMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_93PrhUgHZQOhMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: indexbwk8393i7vMeta || {},
    component: () => import("/codebuild/output/src1852554866/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]